export const lightGrey = '#F5F5F5';
export const mediumGrey = '#505050';
export const darkGrey = '#3B3B3B';
export const font = 'Lato';
export const turquoise = '#61ABB7';
export const lightTurquoise = '#e7f2f4';
export const green = '#84CE5A';
export const red = '#FF3232';
export const primary = '#38398C';
export const secondary = turquoise;

export const getPrimary = () => {
	const actual = document.documentElement.style.getPropertyValue('--primary') || primary;
	return actual;
};

export const getSecondary = () => {
	const actual = document.documentElement.style.getPropertyValue('--secondary') || secondary;
	return actual;
};

export const getPortalPrimary = () => {
	const actual = document.documentElement.style.getPropertyValue('--portalPrimary') || primary;
	return actual;
};

export const getPortalSecondary = () => {
	const actual = document.documentElement.style.getPropertyValue('--portalSecondary') || secondary;
	return actual;
};

export const getLightGrey = () => lightGrey;
